import type { FavoritesConfig } from '#types/config/components/favorites'
import type { RecursivePartial } from '#types/utils'

export default {
  dialogOptions: { type: 'panel' },
  list: {
    brandClasses: {
      title: 'body-1'
    }
  },
  unauthenticatedCtaPosition: 'before-list'
} satisfies RecursivePartial<FavoritesConfig>
